import { OrderCompact, OrderStateEnum } from '@lib/types';

import { client } from './client';
import { endpoints } from './endpoints';

type historyOrders = {
  items: OrderCompact[];
  haxNext: boolean;
};

export async function fetchHistory(
  pageNumber: number,
  states: OrderStateEnum[],
  phoneNumber?: string,
): Promise<historyOrders> {
  const response = await client.post(endpoints.HISTORY, {
    pagination: {
      page: pageNumber,
      pageSize: 10,
    },
    states,
    ...(phoneNumber && { phoneNumber: [phoneNumber] }),
  });

  return response.data;
}
